import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
/**
 * Zustand auth store persisted to localStorage under the `ww-auth` key.
 * The SB3 backend issues bearer JWTs (no httpOnly cookie in this flow),
 * so the token has to survive reloads; we accept the XSS trade-off the
 * legacy portal already lived with. The refresh token sits beside the
 * access token in the same store — when the access token 401s, the
 * api client transparently rotates the pair without bouncing the user.
 */
export const useAuthStore = create()(persist((set) => ({
    accessToken: null,
    refreshToken: null,
    user: null,
    lastAuthAt: null,
    setAuth: ({ accessToken, refreshToken, user }) => set({
        accessToken,
        refreshToken: refreshToken ?? null,
        user,
        lastAuthAt: Date.now(),
    }),
    setAccessToken: (accessToken) => set({ accessToken }),
    setTokens: ({ accessToken, refreshToken }) => set({ accessToken, refreshToken }),
    clearAuth: () => set({ accessToken: null, refreshToken: null, user: null, lastAuthAt: null }),
}), {
    name: 'ww-auth',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
        lastAuthAt: state.lastAuthAt,
    }),
}));
/**
 * Convenience selector — returns true if the user has a role that allows
 * administrative actions (admin or superUser). Billing + standard users
 * see a reduced nav + dashboard-only experience.
 */
export function isAdmin(user) {
    return !!(user?.admin || user?.superUser);
}
export function isBillingOrAdmin(user) {
    return !!(user?.admin || user?.superUser || user?.billingUser);
}
